<template>
  <transition-group tag="div" appear :data-layout="renderedLayoutType" name="fade-up" class="listing-feed__set">
    <component :is="cardType" :show-angled-image="showAngledImage" :featured-card="featuredCardCheck" :show-arrows="showArrows" :hierarchical-headings="hierarchicalHeadings" :hide-tags="hideTags" :default-selected-tags="defaultSelectedTags" v-for="(item, index) in data" :item="item" :index="index" :key="item.Id" />
  </transition-group>
</template>

<script>

import InfoCard from '../cards/info-card.vue'
import DayOutInfoCard from '../cards/day-out-info-card.vue'
export default {
    components: {
        InfoCard,
        DayOutInfoCard
    },
    props: {
        data: {
            type: Array,
            required: true
        },
        defaultSelectedTags: {
            type: Array,
            default: () => []
        },
        hideTags: {
            type: String,
            required: false,
            default: ''
        },
        layout: {
            type: String,
            required: false,
            default: '3'
        },
        hierarchicalHeadings: {
            type: Boolean,
            required: false
        },
        showArrows: {
            type: Boolean,
            required: false
        },
        showAngledImage: {
            type: Boolean,
            required: false
        },
        featuredCard: {
            type: Boolean,
            required: false
        },
        dayOutCard: {
            type: Boolean,
            required: false
        },
        index: {
            type: Number,
            required: true
        }
    },
    computed: {
        featuredCardCheck(){
            if(this.index == 0 && this.featuredCard){
                return true
            }
            return false
        },
        cardType() {
            if(this.dayOutCard) {
                return DayOutInfoCard
            }
            return InfoCard
        },
        renderedLayoutType() {
            // used for dayout page, layout changes where they have 1 priority article 
            // on page one, then a 3x3 listing for the rest of the results
            if(this.index > 0 && this.layout == 1|3|3 ){
                return 3|3|3
            }
            return this.layout
        },
    }
}
</script>